import {
  colorsTuple,
  createTheme,
  DefaultMantineColor,
  MantineThemeOverride,
  rem,
  TextInput,
} from '@mantine/core';
import { mantineColors, uiTokens } from './tokens.ts';

const theme: MantineThemeOverride = createTheme({
  // ...DEFAULT_THEME,
  headings: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: '500',
    textWrap: 'wrap',
    sizes: {
      h1: { fontSize: rem(25), fontWeight: '500' },
      h2: { fontSize: rem(15), fontWeight: '500' },
    },
  },

  fontSizes: {
    xs: rem(12),
    sm: rem(13),
    md: rem(14),
    lg: rem(15),
    xl: rem(24),
  },

  lineHeights: {
    xs: '1.4',
    sm: '1.45',
    md: '1.55',
    lg: '1.6',
    xl: '1.65',
  },

  fontFamily: 'Inter, sans-serif',
  colors: {
    primary: [
      uiTokens.brand.pink, // bight pink
      uiTokens.brand.blue, // superman blue
      '#ffe7fb',
      '#ffceef',
      '#ff9ad9',
      '#ff64c4',
      '#ff36b1',
      '#ff18a6',
      '#ff01a0',
      uiTokens.brand.pinkDark,
      '#cd007c',
      '#b4006c',
    ],
    neutrals: [
      '#FFEAF7', // light pink
      '#ECECED', // light grey
      '#BABABA', // medium grey
      '#fff2f5',
      '#ece6e7',
      '#cfcdcd',
      '#b2b2b2',
      '#9a9a9a',
      '#8b8b8b',
      '#848484',
      '#737171',
      '#686465',
      '#5f5457',
    ],
    brandBlue: mantineColors.brandBlue,
    brandPink: mantineColors.brandPink,
    alerts: [
      '#12C267', // success
      '#51ADFF', // in progress
      '#FAF3B2', // warning 1
      '#EFB011', // warning 2
      '#F34F52', // Error
      '#ffe8e9',
      '#ffd1d2',
      '#fba1a3',
      '#f66e70',
      '#f24246',
    ],
    fonts: [
      '#0F172A', // primary font color
      '#FEFEFF', // secondary font color
      '#757575', // tertiary font color
      '#f0f3fa',
      '#dee3ed',
      '#b9c4dd',
      '#92a3cd',
      '#7187c0',
      '#5d75b9',
      '#516db6',
    ],
    'body-bg': colorsTuple('#FBFBFB'),
    'sidebar-bg': colorsTuple('#FEFEFF'),
  },
  primaryColor: 'primary' as DefaultMantineColor,
  primaryShade: 5, // Specify a default shade for primary color

  components: {
    TextInput: TextInput.extend({
      classNames: {},
    }),
    Switch: {
      defaultProps: {
        color: 'brandPink.5',
      },
    },
    Modal: {
      styles: {
        root: {
          '--modal-size-md': '560px',
        },
      },
    },
    // Modal: {
    //   sizes: {
    //     md: '560px',
    //   },
    // },

    //   {
    // classNames: {
    //   root: classes.customTextInputInput,
    //   input: classes.customTextInputInput,
    //   label: classes.customTextInputInput,
    // },
    // styles: (theme: MantineTheme) => ({
    //   input: {
    //     backgroundColor: 'red',
    //     // '&:hover': { backgroundColor: theme.colors.primary[5] },
    //     '&:hover': {
    //       backgroundColor: 'blue',
    //     },
    //   },
    // }),
    // },
    // Textarea: {
    //   styles: (theme: MantineTheme) => ({
    //     input: {
    //       borderColor: theme.colors.velosPrimary[5],
    //       '&:focus': {
    //         borderColor: theme.colors.velosPrimary[5],
    //       },
    //       '&:hover': {
    //         borderColor: theme.colors.brand[5],
    //         borderWidth: '2px', // Thicker border on hover
    //       },
    //     },
    //   }),
    // },
  },

  // components: {
  //   Button: {
  //     styles: (theme: MantineTheme) => ({
  //       root: {
  //         borderWidth: '1px',
  //         borderColor: theme.colors.boogiePrimary[5],
  //         backgroundColor: theme.colors.boogiePrimary[0],
  //         '&:hover': {
  //           backgroundColor: theme.colors.boogiePrimary[1],
  //         },
  //         '&:active': {
  //           backgroundColor: theme.colors.boogiePrimary[2],
  //         },
  //       },
  //     }),
  //   },
  //   Table: {
  //     styles: (theme: MantineTheme) => ({
  //       root: {
  //         borderColor: theme.colors.boogiePrimary[1],
  //         backgroundColor: theme.colors.boogiePrimary[2],
  //       },
  //       th: {
  //         color: theme.colors.boogiePrimary[3],
  //         borderColor: theme.colors.boogiePrimary[4],
  //         backgroundColor: theme.colors.boogiePrimary[5],
  //       },
  //       td: {
  //         borderColor: theme.colors.boogiePrimary[6],
  //         backgroundColor: theme.colors.boogiePrimary[7],
  //       },
  //     }),
  //   },
  //   Drawer: {
  //     styles: (theme: MantineTheme) => ({
  //       root: {
  //         backgroundColor: theme.colors.gray[0],
  //       },
  //     }),
  //   },
  //   Modal: {
  //     styles: (theme: MantineTheme) => ({
  //       root: {
  //         backgroundColor: theme.colors.gray[0],
  //       },
  //     }),
  //   },
  //   Tabs: {
  //     styles: (theme: MantineTheme) => ({
  //       tab: {
  //         color: theme.colors.gray[6],
  //         '&[data-active]': {
  //           color: theme.colors.gray[8],
  //           borderBottom: '3px solid',
  //           borderColor: theme.colors.gray[8],
  //         },
  //       },
  //       tabList: {
  //         display: 'flex',
  //         gap: '1rem',
  //       },
  //     }),
  //   },
  //   Menu: {
  //     styles: (theme: MantineTheme) => ({
  //       item: {
  //         '&:focus': {
  //           backgroundColor: theme.colors.velosPrimary[0],
  //         },
  //         '&:hover': {
  //           backgroundColor: theme.colors.velosPrimary[1],
  //         },
  //         '&:active': {
  //           color: theme.colors.velosPrimary[5],
  //         },
  //       },
  //     }),
  //   },
  //   Badge: {
  //     styles: (theme: MantineTheme) => ({
  //       root: {
  //         backgroundColor: theme.colors.boogiePrimary[3],
  //         color: theme.white, // Use theme.white instead of theme.colors.white
  //       },
  //     }),
  //   },
  //   Anchor: {
  //     styles: (theme: MantineTheme) => ({
  //       root: {
  //         color: theme.colors.boogiePrimary[5],
  //         '&:hover': {
  //           color: theme.colors.boogiePrimary[6],
  //         },
  //       },
  //     }),
  //   },
  //   Text: {
  //     styles: () => ({
  //       root: {
  //         marginBottom: 0,
  //       },
  //     }),
  //   },
  //   TextInput: {
  //     styles: (theme: MantineTheme) => ({
  //       input: {
  //         borderColor: theme.colors.velosPrimary[5],
  //         '&:focus': {
  //           borderColor: theme.colors.velosPrimary[5],
  //         },
  //       },
  //     }),
  //   },
  //   Textarea: {
  //     styles: (theme: MantineTheme) => ({
  //       input: {
  //         borderColor: theme.colors.velosPrimary[5],
  //         '&:focus': {
  //           borderColor: theme.colors.velosPrimary[5],
  //         },
  //       },
  //     }),
  //   },
  // },
});

export default theme;
